import * as api from '../../constants/api'
import callApi from '../http'

const fuelRequestLocal = async (body) => await callApi(api.FUEL_REQUEST_LOCAL, body)

const operatorFuelRequestHistoryLocal = async (body) => await callApi(api.OPERATOR_FUEL_REQUEST_HISTORY_LOCAL, body)

export {
    fuelRequestLocal,
    operatorFuelRequestHistoryLocal
}